const I18N = {
  en: {
    placeholder: { select: 'Select an option…' },
    btn: { submit: 'Submit Request' },
    optional: '(optional)',
    subCategoryLabel: 'Sub Category',
    success: "Your request has been submitted. We'll be in touch within 1–2 business days.",
    error: 'Something went wrong. Please try again or contact us directly.',
    address: {
      street: 'Street Address',
      city: 'City',
      country: 'Country',
      stateProvince: 'State / Province',
      postalCode: 'Zip / Postal Code',
    },
  },
  fr: {
    placeholder: { select: 'Sélectionnez une option…' },
    btn: { submit: 'Soumettre la demande' },
    optional: '(facultatif)',
    subCategoryLabel: 'Sous-catégorie',
    success: 'Votre demande a été soumise. Nous vous répondrons dans 1 à 2 jours ouvrables.',
    error: "Une erreur s'est produite. Veuillez réessayer ou nous contacter directement.",
    address: {
      street: 'Adresse',
      city: 'Ville',
      country: 'Pays',
      stateProvince: 'État / Province',
      postalCode: 'Code postal',
    },
  },
};

const COUNTRIES = [
  { value: 'US', label: { en: 'United States', fr: 'États-Unis' } },
  { value: 'CA', label: { en: 'Canada', fr: 'Canada' } },
];

const US_STATES = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
];

const CA_PROVINCES = [
  { value: 'AB', label: { en: 'Alberta', fr: 'Alberta' } },
  { value: 'BC', label: { en: 'British Columbia', fr: 'Colombie-Britannique' } },
  { value: 'MB', label: { en: 'Manitoba', fr: 'Manitoba' } },
  { value: 'NB', label: { en: 'New Brunswick', fr: 'Nouveau-Brunswick' } },
  { value: 'NL', label: { en: 'Newfoundland and Labrador', fr: 'Terre-Neuve-et-Labrador' } },
  { value: 'NS', label: { en: 'Nova Scotia', fr: 'Nouvelle-Écosse' } },
  { value: 'NT', label: { en: 'Northwest Territories', fr: 'Territoires du Nord-Ouest' } },
  { value: 'NU', label: { en: 'Nunavut', fr: 'Nunavut' } },
  { value: 'ON', label: { en: 'Ontario', fr: 'Ontario' } },
  { value: 'PE', label: { en: 'Prince Edward Island', fr: 'Île-du-Prince-Édouard' } },
  { value: 'QC', label: { en: 'Quebec', fr: 'Québec' } },
  { value: 'SK', label: { en: 'Saskatchewan', fr: 'Saskatchewan' } },
  { value: 'YT', label: { en: 'Yukon', fr: 'Yukon' } },
];

function buildCategories(locale) {
  const isEn = locale === 'en';

  const retailers = [
    { value: 'amazon',       label: 'Amazon' },
    { value: 'bestar',       label: 'Bestar' },
    { value: 'costco',       label: 'Costco' },
    { value: 'office-depot', label: 'Office Depot' },
    { value: 'overstock',    label: 'Overstock / Bed Bath and Beyond' },
    { value: 'staples',      label: 'Staples' },
    { value: 'wayfair',      label: 'Wayfair' },
    { value: 'other',        label: isEn ? 'Other' : 'Autre' },
  ];

  // ── Shared field definitions ─────────────────────────────────────────────
  const fullName = { name: 'full_name',           label: isEn ? 'Full Name'            : 'Nom complet',                      required: true  };
  const email    = { name: 'email_address',        label: isEn ? 'Email Address'        : 'Adresse courriel',                  required: true,  type: 'email' };
  const phone    = { name: 'phone_number',         label: isEn ? 'Phone Number'         : 'Numéro de téléphone',              required: true,  type: 'tel'   };
  const ship     = { name: 'shipping_address',     label: isEn ? 'Shipping Address'     : 'Adresse de livraison',              required: true,  type: 'address' };
  const newShip  = { name: 'new_shipping_address', label: isEn ? 'New Shipping Address' : 'Nouvelle adresse de livraison',     required: true,  type: 'address' };
  const vendor   = { name: 'vendor',               label: isEn ? 'Vendor / Retailer'   : 'Vendeur / Détaillant',               required: true,  type: 'select', options: retailers };
  const orderNum = { name: 'order_number',         label: isEn ? 'Order Number'         : 'Numéro de commande',                required: true  };
  const modelNum = { name: 'model_number',         label: isEn ? 'Model Number'         : 'Numéro de modèle',                 required: true  };
  const partNum  = { name: 'part_number',          label: isEn ? 'Part Number'          : 'Numéro de pièce',                  required: true  };

  // ── Reusable field-set patterns ──────────────────────────────────────────
  // Note: email is captured separately in Step 2 ("Your email address"), so it
  // is intentionally excluded from the detail-field base set here.
  const base = [fullName, phone, ship];
  const A  = [...base, vendor, orderNum];                          // base + vendor + order#
  const B  = [...base, newShip, vendor, orderNum];                 // base + new shipping + vendor + order#
  const C  = [...base, vendor, orderNum, modelNum, partNum];       // missing / damaged parts (full)
  const D  = [...base, vendor, orderNum, modelNum];                // assembly / shipping damage / warranty
  const E  = [...base, vendor, orderNum, modelNum, partNum];       // product info / missing item in shipping
  const G  = [...base];                                             // sample request (no vendor / order#)
  const H  = [...base, vendor];                                     // promo / taxes (no order#)
  const J  = [...base, modelNum];                                   // new order (no vendor / order#)

  return [
    // ── 1. My Orders ────────────────────────────────────────────────────────
    {
      value: 'my-orders',
      label: isEn ? 'My Orders' : 'Mes commandes',
      subcategories: [
        { value: 'new-order',       label: isEn ? 'I would like to place a new order'       : 'Je souhaite passer une nouvelle commande',          fields: J },
        { value: 'sample-request',  label: isEn ? 'I would like to submit a sample request' : "Je souhaite soumettre une demande d'échantillon",    fields: G },
        { value: 'change-cancel',   label: isEn ? 'Change or cancel my order'               : 'Modifier ou annuler ma commande',                    fields: A },
        { value: 'update-address',  label: isEn ? 'Update my shipping address'              : 'Mettre à jour mon adresse de livraison',             fields: B },
        { value: 'promo-pricing',   label: isEn ? 'Promo code or pricing question'          : 'Code promo ou question de prix',                     fields: H },
        { value: 'payment-issue',   label: isEn ? 'Payment or checkout issue'               : 'Problème de paiement ou de caisse',                  fields: B },
        { value: 'taxes-fees',      label: isEn ? 'Question about taxes or fees'            : 'Question sur les taxes ou frais',                    fields: H },
        { value: 'invoice-receipt', label: isEn ? 'Request an invoice or receipt'           : 'Demander une facture ou un reçu',                    fields: B },
        { value: 'duplicate-order', label: isEn ? 'I was charged twice / duplicate order'   : "J'ai été facturé deux fois / commande en double",    fields: B },
        { value: 'order-other',     label: isEn ? 'Something else about my order'           : 'Autre chose concernant ma commande',                 fields: B },
      ],
    },

    // ── 2. Shipping & Delivery ───────────────────────────────────────────────
    {
      value: 'shipping-delivery',
      label: isEn ? 'Shipping & Delivery' : 'Expédition et livraison',
      subcategories: [
        { value: 'track-order',          label: isEn ? 'Track my order'                                          : 'Suivre ma commande',                                                   fields: B },
        { value: 'arrival-date',         label: isEn ? 'When will my order arrive?'                              : 'Quand mon colis arrivera-t-il?',                                        fields: B },
        { value: 'reschedule',           label: isEn ? 'Reschedule my delivery'                                  : 'Reprogrammer ma livraison',                                             fields: B },
        { value: 'missed-delivery',      label: isEn ? 'I missed my delivery'                                    : "J'ai manqué ma livraison",                                              fields: B },
        { value: 'update-delivery-addr', label: isEn ? 'Update my delivery address'                              : 'Mettre à jour mon adresse de livraison',                               fields: B },
        { value: 'delivery-instructions',label: isEn ? 'Add / change delivery instructions'                      : 'Ajouter / modifier les instructions de livraison',                     fields: B },
        { value: 'access-issue',         label: isEn ? 'Delivery access issue (stairs, elevator, doorway)'       : "Problème d'accès à la livraison (escaliers, ascenseur, porte)",        fields: B },
        { value: 'arrived-damaged',      label: isEn ? 'My order arrived damaged'                                : 'Ma commande est arrivée endommagée',                                    fields: B },
        { value: 'wrong-item',           label: isEn ? 'I received the wrong item'                               : "J'ai reçu le mauvais article",                                          fields: B },
        { value: 'missing-item',         label: isEn ? 'Part of my order is missing'                             : 'Une partie de ma commande est manquante',                              fields: E },
        { value: 'shipping-other',       label: isEn ? 'Something else about my delivery'                        : 'Autre chose concernant ma livraison',                                  fields: B },
      ],
    },

    // ── 3. Returns ──────────────────────────────────────────────────────────
    {
      value: 'returns',
      label: isEn ? 'Returns' : 'Retours',
      subcategories: [
        { value: 'start-return',  label: isEn ? 'Start a return'                             : 'Initier un retour',                                            fields: A },
        { value: 'return-status', label: isEn ? 'Check my return status or label issue'      : "Vérifier mon statut de retour ou problème d'étiquette",        fields: A },
        { value: 'return-other',  label: isEn ? 'Something else about my return'             : 'Autre chose concernant mon retour',                            fields: A },
      ],
    },

    // ── 4. Assembly ─────────────────────────────────────────────────────────
    {
      value: 'assembly',
      label: isEn ? 'Assembly' : 'Assemblage',
      subcategories: [
        { value: 'need-help',       label: isEn ? 'I need help with assembly'              : "J'ai besoin d'aide pour l'assemblage",           fields: D },
        { value: 'no-instructions', label: isEn ? "I didn't receive assembly instructions" : "Je n'ai pas reçu les instructions d'assemblage", fields: D },
        { value: 'assembly-other',  label: isEn ? 'Something else about assembly'          : "Autre chose concernant l'assemblage",            fields: D },
      ],
    },

    // ── 5. Missing Parts or Hardware ────────────────────────────────────────
    {
      value: 'missing-parts',
      label: isEn ? 'Missing Parts or Hardware' : 'Pièces ou quincaillerie manquantes',
      subcategories: [
        { value: 'missing-part', label: isEn ? "I'm missing a part from my order"   : 'Il manque une pièce dans ma commande',          fields: C },
        { value: 'parts-other',  label: isEn ? 'Something else about missing parts' : 'Autre chose concernant les pièces manquantes',  fields: C },
      ],
    },

    // ── 6. Damaged Parts ────────────────────────────────────────────────────
    {
      value: 'damaged-parts',
      label: isEn ? 'Damaged Parts' : 'Pièces endommagées',
      subcategories: [
        { value: 'part-damaged',  label: isEn ? 'A part arrived damaged'               : 'Une pièce est arrivée endommagée',              fields: C },
        { value: 'damage-other',  label: isEn ? 'Something else about damaged parts'   : 'Autre chose concernant les pièces endommagées', fields: C },
      ],
    },

    // ── 7. Product Information ───────────────────────────────────────────────
    {
      value: 'product-info',
      label: isEn ? 'Product Information' : 'Informations sur le produit',
      subcategories: [
        { value: 'product-details', label: isEn ? 'Questions about product details (size, materials, finishes)' : 'Questions sur les détails du produit (taille, matériaux, finitions)', fields: E },
        { value: 'product-other',   label: isEn ? 'Something else about the product'                           : 'Autre chose concernant le produit',                                   fields: E },
      ],
    },

    // ── 8. Safety Incident ──────────────────────────────────────────────────
    {
      value: 'safety-incident',
      label: isEn ? 'Safety Incident' : 'Incident de sécurité',
      subcategories: [
        { value: 'near-miss',       label: isEn ? 'Potential safety concern (near miss)'  : 'Problème de sécurité potentiel (quasi-accident)',    fields: A },
        { value: 'injury',          label: isEn ? 'Report an injury'                      : 'Signaler une blessure',                              fields: A },
        { value: 'property-damage', label: isEn ? 'Report property damage'                : 'Signaler des dommages matériels',                    fields: A },
        { value: 'safety-other',    label: isEn ? 'Something else about safety incidents' : 'Autre chose concernant les incidents de sécurité',   fields: A },
      ],
    },

    // ── 9. Shipping Damage or Loss ──────────────────────────────────────────
    {
      value: 'shipping-damage',
      label: isEn ? 'Shipping Damage or Loss' : "Dommages ou perte lors de l'expédition",
      subcategories: [
        { value: 'lost-shipping',     label: isEn ? 'My order was lost during shipping'         : "Ma commande a été perdue lors de l'expédition",                    fields: A },
        { value: 'damaged-shipping',  label: isEn ? 'My product was damaged in shipping'        : "Mon produit a été endommagé lors de l'expédition",                 fields: D },
        { value: 'shipping-property', label: isEn ? 'Shipping caused property damage'           : "L'expédition a causé des dommages matériels",                      fields: D },
        { value: 'ship-damage-other', label: isEn ? 'Something else about shipping damage/loss' : "Autre chose concernant les dommages/pertes lors de l'expédition",  fields: D },
      ],
    },

    // ── 10. Warranty Activation ─────────────────────────────────────────────
    {
      value: 'warranty',
      label: isEn ? 'Warranty Activation' : 'Activation de la garantie',
      subcategories: [
        { value: 'warranty-issue', label: isEn ? 'Activate warranty - my product has an issue' : 'Activer la garantie - mon produit a un problème',          fields: D },
        { value: 'warranty-fine',  label: isEn ? 'Activate warranty - my product is fine'      : 'Activer la garantie - mon produit fonctionne bien',         fields: D },
        { value: 'warranty-other', label: isEn ? 'Something else about warranty activation'    : "Autre chose concernant l'activation de la garantie",        fields: D },
      ],
    },
  ];
}

const CATEGORIES = {
  en: buildCategories('en'),
  fr: buildCategories('fr'),
};

const CONSUMER_SERVICE_CATEGORIES = new Set([
  'shipping-delivery',
  'assembly',
  'missing-parts',
  'damaged-parts',
  'safety-incident',
  'warranty',
]);

const FREIGHT_CATEGORIES = new Set(['returns', 'shipping-damage']);

class FormspreeRequest {
  constructor(el) {
    this.el = el;
    this.locale = el.dataset.locale === 'fr' ? 'fr' : 'en';
    this.formspreeIdWebsales = el.dataset.formspreeIdWebsales || '';
    this.formspreeIdConsumer = el.dataset.formspreeIdConsumer || '';
    this.formspreeIdFreight = el.dataset.formspreeIdFreight || '';
    this.t = I18N[this.locale];
    this.categories = CATEGORIES[this.locale];
    this.state = { category: null, subCategory: null };
    this._fieldCounter = 0;

    this.form = el.querySelector('[data-form]');
    this.progressFill = el.querySelector('[data-progress-fill]');
    this.progressBar = el.querySelector('[role="progressbar"]');
    this.categorySelect = el.querySelector('[data-category-select]');
    this.subCategorySelect = el.querySelector('[data-sub-category-select]');
    this.subSectionLabel = el.querySelector('[data-sub-section-label]');
    this.subCategoryLabelText = el.querySelector('[data-sub-category-label-text]');
    this.detailFields = el.querySelector('[data-detail-fields]');
    this.submitArea = el.querySelector('[data-submit-area]');
    this.submitBtn = el.querySelector('[data-submit-btn]');
    this.msgSuccess = el.querySelector('[data-msg-success]');
    this.msgError = el.querySelector('[data-msg-error]');
    this.fileInput = el.querySelector('[data-file-input]');
    this.fileNames = el.querySelector('[data-file-names]');
    this.fileDropZone = el.querySelector('[data-file-drop-zone]');
    this.categoryLabelField = el.querySelector('[data-category-label]');
    this.subCategoryLabelField = el.querySelector('[data-sub-category-label]');
    this.subjectMirror = el.querySelector('[data-subject-mirror]');
    this.replyEmailInput = el.querySelector('[data-reply-email]');

    this.groups = {
      category: el.querySelector('[data-group="category"]'),
      sub: el.querySelector('[data-group="sub"]'),
      detail: el.querySelector('[data-group="detail"]'),
      footer: el.querySelector('[data-group="footer"]'),
    };

    this._init();
  }

  _init() {
    if (this.form && this.formspreeIdWebsales) {
      this.form.action = `https://formspree.io/f/${this.formspreeIdWebsales}`;
    }
    this._renderCategories();
    this._bindEvents();
  }

  // ─── Categories ───────────────────────────────────────────────────────────────

  _renderCategories() {
    if (!this.categorySelect) return;
    this.categories.forEach((cat) => {
      const opt = document.createElement('option');
      opt.value = cat.value;
      opt.textContent = cat.label;
      this.categorySelect.appendChild(opt);
    });
  }

  _onCategoryChange() {
    const cat = this.categories.find((c) => c.value === this.categorySelect.value);
    this.state.category = cat || null;
    this.state.subCategory = null;
    if (!cat) return;

    let formId = this.formspreeIdWebsales;
    if (CONSUMER_SERVICE_CATEGORIES.has(cat.value)) {
      formId = this.formspreeIdConsumer;
    } else if (FREIGHT_CATEGORIES.has(cat.value)) {
      formId = this.formspreeIdFreight || this.formspreeIdWebsales;
    }
    if (this.form && formId) {
      this.form.action = `https://formspree.io/f/${formId}`;
    }

    // Update section heading and sub-category select label
    if (this.subSectionLabel) this.subSectionLabel.textContent = cat.label;
    if (this.categoryLabelField) this.categoryLabelField.value = cat.label;
    if (this.subCategoryLabelText) {
      this.subCategoryLabelText.textContent = `${cat.label} - ${this.t.subCategoryLabel}`;
    }

    if (this.subCategorySelect) {
      this.subCategorySelect.innerHTML = `<option value="" disabled selected>${this.t.placeholder.select}</option>`;
      cat.subcategories.forEach((sub) => {
        const opt = document.createElement('option');
        opt.value = sub.value;
        opt.textContent = sub.label;
        this.subCategorySelect.appendChild(opt);
      });
      this.subCategorySelect.value = '';
    }

    this._showGroup('sub');
    this._hideGroup('detail');
    this._hideGroup('footer');
    this._hideSubmit();
    if (this.detailFields) this.detailFields.innerHTML = '';
    this._setProgress(40);
  }

  _onSubCategoryChange() {
    const sub = this.state.category?.subcategories.find(
      (s) => s.value === this.subCategorySelect.value
    );
    this.state.subCategory = sub || null;
    if (!sub) return;
    if (this.subCategoryLabelField) this.subCategoryLabelField.value = sub.label;

    if (this.detailFields) {
      this.detailFields.innerHTML = '';
      if (sub.fields.length > 0) {
        sub.fields.forEach((f) => this.detailFields.appendChild(this._createField(f)));
        this._showGroup('detail');
      } else {
        this._hideGroup('detail');
      }
    }

    this._showGroup('footer');
    this._showSubmit();
    this._setProgress(75);
  }

  _createField(def) {
    if (def.type === 'address') return this._createAddressGroup(def);

    const wrapper = document.createElement('div');
    wrapper.className = 'fsr-field';

    const id = `fsr-dyn-${def.name}-${++this._fieldCounter}`;

    const label = document.createElement('label');
    label.htmlFor = id;

    const labelText = document.createElement('span');
    labelText.textContent = def.label;

    const indicator = document.createElement('span');
    if (def.required) {
      indicator.className = 'fsr-required-dot';
      indicator.setAttribute('aria-hidden', 'true');
    } else {
      indicator.className = 'fsr-optional-tag';
      indicator.textContent = this.t.optional;
    }

    label.appendChild(labelText);
    label.appendChild(indicator);
    wrapper.appendChild(label);

    if (def.type === 'select') {
      const select = document.createElement('select');
      select.id = id;
      select.name = def.name;
      if (def.required) {
        select.required = true;
        select.setAttribute('aria-required', 'true');
      }
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.disabled = true;
      placeholder.selected = true;
      placeholder.textContent = this.t.placeholder.select;
      select.appendChild(placeholder);
      (def.options || []).forEach((opt) => {
        const o = document.createElement('option');
        o.value = opt.value;
        o.textContent = opt.label;
        select.appendChild(o);
      });
      wrapper.appendChild(select);
    } else {
      const input = document.createElement('input');
      input.type = def.type || 'text';
      input.id = id;
      input.name = def.name;
      input.placeholder = def.placeholder || '';
      if (def.required) {
        input.required = true;
        input.setAttribute('aria-required', 'true');
      }
      if (def.type === 'email') input.autocomplete = 'email';
      if (def.type === 'tel') input.autocomplete = 'tel';
      wrapper.appendChild(input);
    }

    return wrapper;
  }

  _createAddressGroup(def) {
    const wrapper = document.createElement('div');
    wrapper.className = 'fsr-address-group';

    const legend = document.createElement('div');
    legend.className = 'fsr-address-group-label';

    const legendText = document.createElement('span');
    legendText.textContent = def.label;
    legend.appendChild(legendText);

    if (def.required) {
      const dot = document.createElement('span');
      dot.className = 'fsr-required-dot';
      dot.setAttribute('aria-hidden', 'true');
      legend.appendChild(dot);
    }
    wrapper.appendChild(legend);

    const grid = document.createElement('div');
    grid.className = 'fsr-address-grid';
    wrapper.appendChild(grid);

    const countryOptions = COUNTRIES.map((c) => ({ value: c.value, label: c.label[this.locale] }));

    const streetEl  = this._createField({ name: def.name,                     label: this.t.address.street,        required: true });
    const cityEl    = this._createField({ name: `${def.name}_city`,           label: this.t.address.city,          required: true });
    const countryEl = this._createField({ name: `${def.name}_country`,        label: this.t.address.country,       required: true, type: 'select', options: countryOptions });
    const stateEl   = this._createField({ name: `${def.name}_state_province`, label: this.t.address.stateProvince, required: true, type: 'select', options: [] });
    const zipEl     = this._createField({ name: `${def.name}_postal_code`,    label: this.t.address.postalCode,    required: true });

    grid.append(streetEl, cityEl, countryEl, stateEl, zipEl);

    const countrySelect = countryEl.querySelector('select');
    const stateSelect = stateEl.querySelector('select');

    countrySelect.addEventListener('change', () => {
      const list = countrySelect.value === 'CA' ? CA_PROVINCES : countrySelect.value === 'US' ? US_STATES : [];
      stateSelect.innerHTML = '';
      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.disabled = true;
      placeholder.selected = true;
      placeholder.textContent = this.t.placeholder.select;
      stateSelect.appendChild(placeholder);
      list.forEach((p) => {
        const o = document.createElement('option');
        o.value = p.value;
        o.textContent = typeof p.label === 'string' ? p.label : p.label[this.locale];
        stateSelect.appendChild(o);
      });
    });

    return wrapper;
  }

  // ─── Group visibility ─────────────────────────────────────────────────────────

  _showGroup(name) {
    const g = this.groups[name];
    if (!g) return;
    g.classList.add('visible');
    g.removeAttribute('aria-hidden');
  }

  _hideGroup(name) {
    const g = this.groups[name];
    if (!g) return;
    g.classList.remove('visible');
    g.setAttribute('aria-hidden', 'true');
  }

  _showSubmit() {
    if (!this.submitArea) return;
    this.submitArea.style.display = 'flex';
    this.submitArea.removeAttribute('aria-hidden');
  }

  _hideSubmit() {
    if (!this.submitArea) return;
    this.submitArea.style.display = 'none';
    this.submitArea.setAttribute('aria-hidden', 'true');
  }

  // ─── Progress bar ─────────────────────────────────────────────────────────────

  _setProgress(pct) {
    if (this.progressFill) this.progressFill.style.width = `${pct}%`;
    if (this.progressBar) this.progressBar.setAttribute('aria-valuenow', pct);
  }

  // ─── File upload ──────────────────────────────────────────────────────────────

  _updateFileNames() {
    if (!this.fileInput || !this.fileNames) return;
    this.fileNames.textContent = Array.from(this.fileInput.files)
      .map((f) => f.name)
      .join(', ');
  }

  // ─── Form submission ──────────────────────────────────────────────────────────

  async _onSubmit(e) {
    e.preventDefault();

    if (!this.form.action.includes('formspree.io')) {
      this._showMessage('error', this.t.error);
      return;
    }

    if (!this._validate()) return;

    this._setSubmitting(true);
    this._hideMessage('success');
    this._hideMessage('error');

    try {
      const res = await fetch(this.form.action, {
        method: 'POST',
        body: new FormData(this.form),
        headers: { Accept: 'application/json' },
      });

      if (res.ok) {
        this._setProgress(100);
        this._showMessage('success', this.t.success);
        setTimeout(() => {
          this.form.reset();
          this._resetState();
        }, 1200);
      } else {
        const json = await res.json().catch(() => ({}));
        this._showMessage('error', json.error || this.t.error);
      }
    } catch {
      this._showMessage('error', this.t.error);
    } finally {
      this._setSubmitting(false);
    }
  }

  _validate() {
    const required = Array.from(this.form.querySelectorAll('[required]'));
    required.forEach((f) => f.removeAttribute('aria-invalid'));
    const empty = required.find((f) => !f.value.trim());
    if (empty) {
      empty.setAttribute('aria-invalid', 'true');
      empty.addEventListener('input', () => empty.removeAttribute('aria-invalid'), { once: true });
      empty.focus();
      return false;
    }
    return true;
  }

  _setSubmitting(on) {
    if (!this.submitBtn) return;
    this.submitBtn.disabled = on;
    if (on) {
      this.submitBtn.innerHTML = `
        <span class="fsr-spinner" aria-hidden="true"></span>
        <span>${this.t.btn.submit}</span>`;
    } else {
      this.submitBtn.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <line x1="22" y1="2" x2="11" y2="13"/>
          <polygon points="22 2 15 22 11 13 2 9 22 2"/>
        </svg>
        <span>${this.t.btn.submit}</span>`;
    }
  }

  _showMessage(type, text) {
    const el = type === 'success' ? this.msgSuccess : this.msgError;
    if (!el) return;
    el.textContent = text;
    el.style.display = 'block';
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  _hideMessage(type) {
    const el = type === 'success' ? this.msgSuccess : this.msgError;
    if (!el) return;
    el.style.display = 'none';
    el.textContent = '';
  }

  _resetState() {
    this.state = { category: null, subCategory: null };
    this._hideGroup('sub');
    this._hideGroup('detail');
    this._hideGroup('footer');
    this._hideSubmit();
    if (this.detailFields) this.detailFields.innerHTML = '';
    if (this.fileNames) this.fileNames.textContent = '';
    if (this.replyEmailInput) this.replyEmailInput.value = '';
    this._setProgress(10);
  }

  // ─── Event binding ────────────────────────────────────────────────────────────

  _bindEvents() {
    this.categorySelect?.addEventListener('change', () => this._onCategoryChange());
    this.subCategorySelect?.addEventListener('change', () => this._onSubCategoryChange());
    this.form?.addEventListener('submit', (e) => this._onSubmit(e));

    const subjectInput = this.el.querySelector('[data-subject-input]');
    if (subjectInput && this.subjectMirror) {
      subjectInput.addEventListener('input', () => {
        this.subjectMirror.value = subjectInput.value;
      });
    }

    this.fileInput?.addEventListener('change', () => this._updateFileNames());

    this.fileDropZone?.addEventListener('dragover', (e) => {
      e.preventDefault();
      this.fileDropZone.classList.add('drag-over');
    });
    this.fileDropZone?.addEventListener('dragleave', () => {
      this.fileDropZone.classList.remove('drag-over');
    });
    this.fileDropZone?.addEventListener('drop', (e) => {
      e.preventDefault();
      this.fileDropZone.classList.remove('drag-over');
      if (this.fileInput && e.dataTransfer?.files) {
        this.fileInput.files = e.dataTransfer.files;
        this._updateFileNames();
      }
    });
  }
}

export default (el) => new FormspreeRequest(el);
